import { Show, TopToolbar } from 'react-admin'
import ImpiantiReferenceManutenzioni from './ImpiantiReferenceManutenzioni';
import ImpiantiReferenceProdotti from './ImpiantiReferenceProdotti';
import { IndietroButton } from './util/ItasEditActions';

export const ImpiantiShow = () => {
    const ListActions = () => (
        <TopToolbar>
            {/*<EditButton label="Modifica impianto"/> not needed?*/ }
            <IndietroButton />
        </TopToolbar>
      );
    return (
        <>
            <Show title="Dettagli impianto" className='py-6'
                actions={<ListActions />}>
                
                <div style={{minHeight: "30px"}}></div>
                <ImpiantiReferenceProdotti style={{marginTop: "2em"}} />
                <div style={{minHeight: "30px"}}></div>
                <ImpiantiReferenceManutenzioni />
                <div style={{minHeight: "30px"}}></div>
            </Show>
        </>
        
    );
};